import { GenerarFicheroModelo180CommandProps } from "api/Commands/GenerarFicheroModelo180Command"
import { PerceptorDeclaracionModelo180DtoProps } from "api/DTOs/PerceptorDeclaracionModelo180Dto"
import { ModalidadModelo180Type } from "api/Types/ModalidadModelo180"
import { SituacionInmuebleModelo180Type } from "api/Types/SituacionInmuebleModelo180"
import { TipoNumeracionType } from "api/Types/TipoNumeracion"
import { TipoViaIneType } from "api/Types/TipoViaIne"

export interface PerceptorFormProps {
  baseRetencion: number
  bloque: string | null
  calificadorNumero: string | null
  codigoMunicipio: string | null
  codigoPostal: string | null
  complemento: string | null
  denominacion: string | null
  ejercicioDevengo: string
  escalera: string | null
  legalRepresentative: string | null
  localidadPoblacion: string | null
  modalidad: ModalidadModelo180Type | null
  municipio: string | null
  nif: string | null
  nombreVia: string | null
  numeroCasa: string | null
  plantaPiso: string | null
  porcentajeRetencion: number
  portal: string | null
  provincia: string | null
  provinciaDos: string | null
  puerta: string | null
  referenciaCatastral: string | null
  retencion: number
  situacionInmueble: SituacionInmuebleModelo180Type
  tipoNumeracion: TipoNumeracionType | null
  tipoVia: TipoViaIneType | null
}
export interface Modelo180FormModel {
  "01": number
  "02": number
  "03": number
  complementariaCheck: boolean
  complementariaDeclaracionAnterior: number
  ejercicio: string
  nif: string | null
  perceptores: PerceptorFormProps[]
  razonSocial: string | null
  sustitutivaCheck: boolean
  sustitutivaDeclaracionAnterior: number
  telefono: string | null
  apellidos: string | null
}
export const postModelo180Adapter = (
  formData: Modelo180FormModel
): GenerarFicheroModelo180CommandProps => {
  return {
    declaracion: {
      declarante: {
        apellidoYNombrePersona: formData?.apellidos,
        declaracionComplementaria: formData?.complementariaCheck,
        declaracionSustitutiva: formData?.sustitutivaCheck,
        importeBaseRetencionesEIngresosACuenta: formData?.["02"],
        nifDeclarante: formData?.nif,
        nombreDeclarante: formData?.razonSocial,
        numeroIdentificativoDeclaracionAnterior:
          formData?.sustitutivaDeclaracionAnterior ||
          formData?.complementariaDeclaracionAnterior ||
          0,
        numeroTotalPerceptores: formData?.["01"],
        retencionesEIngresosACuenta: formData?.["03"],
        telefonoPersona: formData?.telefono,
      },
      ejercicio: formData.ejercicio,
      perceptores: formData?.perceptores?.map(
        (
          perceptor: PerceptorFormProps
        ): PerceptorDeclaracionModelo180DtoProps => ({
          baseRetencionesEIngresosACuenta: perceptor?.baseRetencion,
          bloque: perceptor?.bloque,
          calificadorNumero: perceptor?.calificadorNumero,
          codigoMunicipio: perceptor?.codigoMunicipio,
          codigoPostal: perceptor?.codigoPostal,
          codigoProvincia: perceptor?.provincia,
          codigoProvinciaInmueble: perceptor?.provinciaDos,
          complemento: perceptor?.complemento,
          ejercicioDevengo: perceptor?.ejercicioDevengo,
          escalera: perceptor?.escalera,
          localidadOPoblacion: perceptor?.localidadPoblacion,
          modalidad: perceptor?.modalidad,
          municipio: perceptor?.municipio,
          nifPerceptor: perceptor?.nif,
          nifRepresentanteLegal: perceptor?.legalRepresentative,
          nombrePerceptor: perceptor?.denominacion,
          nombreVia: perceptor?.nombreVia,
          numeroCasa: perceptor?.numeroCasa,
          plantaOPiso: perceptor?.plantaPiso,
          porcentajeRetenciones: perceptor?.porcentajeRetencion,
          portal: perceptor?.portal,
          puerta: perceptor?.puerta,
          referenciaCatastral: perceptor?.referenciaCatastral,
          retencionesEIngresosACuenta: perceptor?.retencion,
          situacionInmueble: perceptor?.situacionInmueble,
          tipoNumeracion: perceptor?.tipoNumeracion,
          tipoVia: perceptor?.tipoVia,
        })
      ),
    },
  }
}
